import initFilter from "../../../src/js/filter";
import { initSwiperCarousel } from "../../../src/utils-shared/swiperCarousel";
import { changeMediaListener } from "../../../src/js/changeMediaListener";
import { getRelatedSliderOptions } from "../../../src/js/utils/sliderOptions";
import { loadVideo } from "../../../src/js/loadVideo";

const formData = {
	"categories[]": [],
	"industries[]": [],
	"expertises[]": [],
	"services[]": [],
	"content_type[]": [],
	"roles[]": [],
	search: "",
};

const featuredSliderOptions = {
	horizontal: {
		slidesPerView: 1,
		spaceBetween: 20,
		freeMode: true,
		pagination: {
			el: ".js-swiper-pagination",
			clickable: true,
		},
		breakpoints: {
			550: {
				slidesPerView: 2,
			},
			1024: {
				slidesPerView: 3,
			},
		},
		pagination: {
			el: ".js-swiper-pagination",
			clickable: true,
		},
	},
	vertical: {
		direction: "vertical",
		pagination: {
			el: ".js-swiper-pagination",
			clickable: true,
		},
	},
};

document.addEventListener("DOMContentLoaded", async () => {
	const { initTabs } = await import("@utils/tabs");

	const carousels = document.querySelectorAll(
		".b-related_articles-list_wrapper",
	);

	changeMedia();
	initTabs();
	initFilter(formData);

	carousels.forEach((carouselElement) => {
		const options = getRelatedSliderOptions(carouselElement);

		initSwiperCarousel(options, carouselElement, false, true, true);
	});
	loadVideo();
});

function changeMedia() {
	let featuredSlider = null;
	const featuredElem = document.querySelector(".b-blog_hub-featured_slider");

	const initFeaturedSlider = async (direction) => {
		if (featuredSlider) {
			await featuredSlider.destroy();
		}

		featuredSlider = initSwiperCarousel(
			featuredSliderOptions[direction],
			featuredElem,
			true,
			false,
			true,
		);
	};

	const customSizes = [
		{
			handler: () => {
				initFeaturedSlider("horizontal");
			},
			query: "(max-width: 1199px)",
		},
		{
			handler: () => initFeaturedSlider("vertical"),
			query: "(min-width: 1200px)",
		},
	];

	changeMediaListener({
		customSizes,
	});
}
